import Dimensions from "../selectors/Dimensions";

const ColumnsTab = ({ openColumnModal, setFormData }) => (
  <Dimensions openColumnModal={openColumnModal} setFormData={setFormData} />
);

export default ColumnsTab;
